import { createEvent, createStore, sample } from 'effector'
import { ISuggestion } from 'src/features/suggestions/contract'
import { persist } from 'src/shared/lib/effector-storage/local'

export const pushHistorySuggestion = createEvent<ISuggestion>()
export const deleteHistorySuggestion = createEvent<string | number>()

export const clearHistorySuggestion = createEvent()

export const $historySuggestion = createStore<ISuggestion[]>([], { serialize: 'ignore' })

persist({ store: $historySuggestion, key: 'zdr-history-suggestion' })

sample({
    clock: pushHistorySuggestion,
    source: $historySuggestion,
    filter: (_, suggestion) => !!suggestion && !!suggestion.id,
    fn: (history, suggestion): ISuggestion[] => {
        if (history.length === 0) return [suggestion]
        const res = [suggestion, ...history.filter((x) => !(x.id === suggestion.id && x.title === suggestion.title))]
        res.splice(5)
        return res
    },
    target: $historySuggestion
})

sample({
    clock: deleteHistorySuggestion,
    source: $historySuggestion,
    filter: (_, id) => !!id,
    fn: (history, id): ISuggestion[] => {
        const res = history.filter((x) => x.id !== id && x.id.toString() !== id)
        return res
    },
    target: $historySuggestion
})

sample({
    clock: clearHistorySuggestion,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target: $historySuggestion.reinit!
})
